<template>

    <div class="page-dashboard">

      <div class="py-4 mb-4 no-gradient position-relative overflow-hidden">
        <div class="container-fluid px-5">
          <div class="d-flex flex-column flex-sm-row justify-content-sm-between align-items-sm-end py-2 text-center text-sm-left">
            <div class="flex-sm-fill">
              <h1 class="h3 font-w700 mb-0">Dashboard</h1>
  <!--          <h5 class="text-2xl mb-8 text-muted">Monitor your orders and fulfillments.</h5> -->
            </div>
          </div>
        </div>
        <!-- <Snow /> -->
      </div>

      <!-- stat boxes -->
      <div class="container-fluid stat-boxes" style="max-width: 1400px;">
        <div class="row">

          <!-- item -->
          <div class="col-md-6 col-xl-4 mb-3">
            <div class="card h-100 rounded-0">
              <div class="card-body">
                <div class="d-flex">
                  <div class="pr-3 pt-2 align-self-top">
                    <b-icon icon="exclamation-diamond" class="text-secondary" font-scale="3"></b-icon>
                  </div>
                  <div class="align-self-center">
                    <h5 class="text-muted">Order Issues</h5>
                    <div>
                      <div v-if="loading" class="d-flex">
                        <b-skeleton type="button" size="sm" class="mr-2"></b-skeleton>
                        <b-skeleton type="button" size="sm"></b-skeleton>
                      </div>
                      <div v-else style="display: flex; gap: 0.5rem;">
                        <b-button
                          :to="{ name: 'Jobs', query: { status: 'warnings' } }"
                          size="sm"
                          :variant="counts.warnings ? 'danger' : 'outline-secondary'"
                          title="Click to view orders with warnings."
                        >
                          <span class="mr-1">{{ counts.warnings ? counts.warnings : '0' }}</span>
                          <span>Warnings</span>
                        </b-button>

                        <b-button
                          :to="{ name: 'Jobs', query: { status: 'failed' } }"
                          size="sm"
                          :variant="counts.failed ? 'danger' : 'outline-secondary'"
                          title="Click to view orders that have failed. They should either be fixed or cancelled."
                        >
                          <span class="mr-1">{{ counts.failed ? counts.failed : '0' }}</span>
                          <span>Failed</span>
                        </b-button>
                      </div>

                      <!-- <p class="inline-block mb-0 text-secondary text-uppercase text-monospace" :class="{'text-danger': counts.warnings}">Warnings</p>
                      <h4 class="mb-0 ml-2 mr-4 inline-block">
                        <b-link :to="{ name: 'Jobs', query: { status: 'warnings' } }">
                          <span class="">{{ counts.warnings ? counts.warnings : '0' }}</span>
                        </b-link>
                      </h4>
                      <p class="inline-block mb-0 text-secondary text-uppercase text-monospace" :class="{'text-danger': counts.failed}">Failed</p>
                      <h4 class="mb-0 ml-2 inline-block">
                        <b-link :to="{ name: 'Jobs', query: { status: 'failed' } }">
                          <span class="">{{ counts.failed ? counts.failed : '0' }}</span>
                        </b-link>
                      </h4> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- item -->
          <div class="col-md-6 col-xl-4 mb-3">
            <div class="card h-100 rounded-0">
              <div class="card-body">
                <div class="d-flex">
                  <div class="pr-3 align-self-center">
                    <b-icon icon="droplet" class="text-secondary" font-scale="3"></b-icon>
                  </div>
                  <div class="align-self-center">
                    <h5 class="text-muted">Pending production</h5>
                    <h4 class="mb-0">
                      <b-link :to="{ name: 'Jobs', query: { status: 'incoming' } }">
                        <span class="">{{ counts.pending ? counts.pending : '0' }}</span>
                      </b-link>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- item -->
          <div class="col-md-6 col-xl-4 mb-3">
            <div class="card h-100 rounded-0">
              <div class="card-body">
                <div class="d-flex">
                  <div class="pr-3 align-self-center">
                    <b-icon icon="printer" class="text-secondary" font-scale="3"></b-icon>
                  </div>
                  <div class="align-self-center">
                    <h5 class="text-muted">In production</h5>
                    <h4 class="mb-0">
                      <b-link :to="{ name: 'Jobs', query: { status: 'in-production' } }">
                        <span class="">{{ counts.in_production ? counts.in_production : '0' }}</span>
                      </b-link>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- item -->
          <!-- <div class="col-md-6 col-xl-4 mb-3">
            <div class="card h-100 rounded-0">
              <div class="card-body">
                <div class="d-flex">
                  <div class="pr-3 align-self-center">
                    <b-icon icon="pencil-square" class="text-secondary" :class="{'text-danger': ! last_order}" font-scale="3"></b-icon>
                  </div>
                  <div class="align-self-center overflow-hidden">
                    <h5 class="text-muted">Last incoming job</h5>
                    <h4 v-if="last_order.jobid" class="mb-0 text-truncate">
                      <b-link :to="{name:'JobDetails', params: { job_id: last_order.id }}" class="">
                        {{ last_order.jobid }}
                      </b-link>
                    </h4>
                    <h5 v-else class="mb-0 text-truncate">No order</h5>
                  </div>
                </div>
              </div>
            </div>
          </div> -->

        </div>
        <!-- end: stat boxes -->

        <!-- start: CHART -->
        <div class="row">
          <div class="col-sm-12 mb-4">
            <div class="card rounded-0">
              <div class="card-body">
                <p class="text-muted small text-uppercase">Jobs per week</p>
                <ChartLine xxxwidth="null" xxxheight="null" v-if="dataCollection1" :chartData="dataCollection1" :options="chartOptions1"/>
                <b-skeleton-img variant="primary" no-aspect height="400px" v-else></b-skeleton-img>
              </div>
            </div>
          </div>
        </div>
        <!-- end: CHART -->

        <!-- load dynamic content directly from public content file -->
        <HtmlContent :slug="`home-section`" />
      </div>

      <footer>
        <div class="container">
          <div class="row">
            <div class="col-sm-12 text-center mt-4 mb-3">
              <small>© Copyright {{ year }}, <!--<a href="https://systembyran.se/" target="_blank">-->Systembyrån AB<!--</a>--></small>
            </div>
          </div>
        </div>
      </footer>
    </div>

</template>


<script>
import ChartLine from '@/components/ChartLine.vue';
import HtmlContent from '@/components/HtmlContent.vue';


//import Snow from '@/components/Snow.vue'

export default {

  components: {
    ChartLine,
    HtmlContent,
    //Snow,
  },
   

  data() {
    return {
      loading: true,
      error: false,
      
      // Chart Data & Options for Chart 1
      dataCollection1: false,
      chartOptions1: {
        title: {
          display: false,
          text: '',
        },
        legend: {
          display: true,
          position: 'bottom',
        },
        maintainAspectRatio: false, // loong
        responsive: true,
        aspectRatio: 4, // set with and height to null on chart & maintain to true - bug!
        scales: {
          yAxes: [{
            display: true,
            ticks: {
              min: 0, // do not display lower than 0 on y axis (took a while to find)
              callback: function (value) { if (Number.isInteger(value)) { return value; } },
            },
          }]
        },
      },

      counts: {
        processed: 0,
        pending: 0,
        warnings: 0,
        messages: 0
      },

      last_order: [],
    }
  },

  computed: {
    year() {
      return this.$moment( new Date() ).format("YYYY");
    }
  },

  created() {
    // Set Sidebar Active Part
    this.$store.commit("SET_SITE_SETTINGS", {'sidebar_current': 'home'});
  },

  mounted () {
    this.fetchData();
  },

  methods: {
    // FETCH CURRENT ORDER - FRESH DATA
    fetchData() {
      // Reset all
      this.loading = true;

      this.$http.get(`${this.$store.state.api_base_url}/dashboard-stats`)
      .then((result) => {
        if ( result.data.status === 'ok' ) {
          this.dataCollection1 = result.data.chartdata;
          this.counts = result.data.counts;
          this.last_order = result.data.last_order;
          this.loading = false;
        }
        if ( result.data.status !== 'ok' ) {
          this.error = result.data.message || 'Could not load data!';
          this.$toastIt(this.error, {variant: 'danger', autoHideDelay: 2000});
        }
      });
    },

  },
}
</script>

<style lang="scss">
</style>

<style lang="scss" scoped>
//
// Stat Box Sizes
//
.stat-boxes svg { font-size: 500%; }
@media screen and (max-width: 762px) {
  .stat-boxes {
    .card-body { padding: 1rem; }
    //h5 { font-size: 1.25rem; }
    //h4 { font-size: 1.5rem; }
    svg  { font-size: 340%; }
  }
}

//
// Footer
//
footer {
//  margin-top: 5em;
//  padding: 2.5rem 0 1rem 0;
//  border-top: 2px dashed #bebebe;

  font-family: monospace;
  color: #636363;
  a {
    color: #636363;
  }
  a:hover {
    color: #333333;
    text-decoration: none;
  }
}
.gradient{
  background: linear-gradient(to right, #d2cbc7, #817e85);;
}

</style>
